import React from 'react'
import styled from 'styled-components'
import { Color, Colors } from '../styles/Colors';
import { SignInButton } from './SignInButton';
import SEKLogo from './icons/SEKLogo';

const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    background-image: url('/bg-3.jpg');
    background-size: cover;
    background-repeat: no-repeat; 
    background-position: 50% 40%; 
    position: relative; 
    display: grid;
    grid-template-columns: 32px [inner-start] minmax(0, 175rem) [inner-end] 32px;
    place-items: center end; 

    & > div {
        grid-column: inner; 
        display: flex; 
        justify-content: center; 
        align-items: center; 
        border-radius: 4px; 
        max-width: 900px; 
        width: 100%; 
        height: calc(100% - 4rem);
        background-color: rgba(255, 255, 255, 0.25); 
        backdrop-filter: blur(5px); 
        padding: 2rem; 
        position: relative; 

        & > div {
            display: flex; 
            flex-direction: column; 
            align-items: center; 
            justify-content: center; 
            
            & > a {
                position: absolute; 
                top: 3rem; 

                & > svg {
                    width: 100%; 
                    height: 64px; 
                }
            }
            
            & > div {
                display: flex; 
                flex-direction: column; 
                align-items: center; 
                justify-content: center; 
                padding: 0 0 2rem 0;  

                h1 {
                    font-size: 7vh; 
                    font-weight: 200; 
                }
                    
                h2 {
                    font-size: 8vh; 
                }

                p {
                    font-size: 2.5vh; 
                    text-align: center; 
                    word-break: break-word;
                    overflow-wrap: anywhere; 
                }
            }
        }
    }

   @media (max-width: 1450px) {
        & > div {
            max-width: 600px; 
        }
    } 

    @media (max-width: 1150px) {
        place-items: center center; 

        & > div {
            & > div {
                & > a {
                    & > svg {
                        width: 100%; 
                        height: 52px; 
                    }
                }

                & > div {
                    h1 {
                        font-size: 5vh; 
                    }
                        
                    h2 {
                        font-size: 6vh; 
                    }
                }
            }
        }

    }
`;

const LogOutView = ({message}) => {
  return (
    <Wrapper>
        <div>
            <div>
                <a href='https://elstandard.se/'>
                    <SEKLogo />
                </a>
                <div>
                    <h1>Varmt välkommen till</h1>
                    <h2>SEK Admin tools</h2>
                    <p>Genom att logga in får du som medarbetare på SEK Svensk Elstandard tillgång till våra interna verktyg - agenda och rapportgeneratorn.</p>
                </div>
                <SignInButton />
            </div>
        </div>
    </Wrapper>
  )
}

export default LogOutView